<template>
  <header>
    <router-link to="/" class="logo">Prime Fusion</router-link>
    <nav>
      <ul>
        <li><router-link to="/">Home</router-link></li>
        <li><router-link to="/about">About</router-link></li>
        <li><router-link to="/services">Services</router-link></li>
        <li><router-link to="/contact">Contact</router-link></li>
        <li><router-link to="/privacy-policy">Privacy</router-link></li>
      </ul>
    </nav>
  </header>
</template>

<style>
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 15px 30px;
  color: #333;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.logo {
  font-size: 26px;
  font-weight: bold;
  color: #4A5D23; /* Main green */
  text-decoration: none;
}

nav ul {
  list-style: none;
  display: flex;
  gap: 20px;
}

nav ul li {
  display: inline;
}

nav ul li a {
  color: #333;
  text-decoration: none;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 5px;
  transition: background 0.3s, color 0.3s;
}

nav ul li a:hover {
  background: #4A5D23;
  color: white;
}
</style>
